export const LOCAL_STORAGE_KEY_INPUT = 'Y3VycmVudElucHV0VGV4dA==';
export const LOCAL_STORAGE_KEY_INPUT_MENTIONS = 'Y3VycmVudElucHV0TWVudGlvbnM=';
export const LOCAL_STORAGE_KEY_INPUT_GRUPO = 'Y3VycmVudElucHV0VGV4dGFHcnVwbw==';
export const LOCAL_STORAGE_KEY_INPUT_MENTIONS_GRUPO =
  'Y3VycmVudElucHV0TWVudGlvbnNHcnVwbw==';

export const LOCAL_STORAGE_KEY_ORDER_BY_FILA_ESPERA = 'orderByFilaDeEspera';
export const LOCAL_STORAGE_KEY_ORDER_BY_ATENDIMENTOS_INICIADOS =
  'orderByAtendimentosIniciados';
